/**
 * QueryProvider
 * 
 * This component sets up TanStack Query for the application, providing
 * caching, deduplication, and other performance optimizations for data fetching.
 */

import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Global defaults for all queries
      staleTime: 60 * 1000, // 1 minute before data is considered stale
      gcTime: 10 * 60 * 1000, // 10 minutes before unused data is garbage collected
      refetchOnWindowFocus: false, // Don't refetch when window regains focus
      retry: 1, // Retry failed requests once
    },
  },
});

interface QueryProviderProps {
  children: React.ReactNode;
}

export function QueryProvider({ children }: QueryProviderProps) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
}

// Export the queryClient for direct access when needed
export { queryClient };